/* eslint-disable */
export const LANGUAGE = 'lang';
export const USERDATA = 'userdata';
export const OVERDUE = 'overdue';
export const USERTOKEN = 'user_token';
export const ORDERDATA = 'order_data';
export const ORDERID = 'order_id';

const LocalStorage = {
  setLanguage(language) {
    return localStorage.setItem(LANGUAGE, language);
  },
  getLanguage() {
    return localStorage.getItem(LANGUAGE) || 'id';
  },
  setOverdue(overdue) {
    return localStorage.setItem(OVERDUE, overdue);
  },
  getOverdue() {
    return localStorage.getItem(OVERDUE);
  },
  removeOverdue() {
    return localStorage.removeItem(OVERDUE);
  },
  getUserToken(){
    return localStorage.getItem(USERTOKEN);
  },
  setUserToken(userToken){
    return localStorage.setItem(USERTOKEN, userToken);
  },
  setUserData(userdata) {
    return localStorage.setItem(USERDATA, userdata);
  },
  getUserData() {
    return localStorage.getItem(USERDATA);
  },
  setOrderData(OrderData) {
    return localStorage.setItem(ORDERDATA, OrderData);
  },
  getOrderData() {
    return localStorage.getItem(ORDERDATA);
  },
  setOrderId(OrderId) {
    return localStorage.setItem(ORDERID, OrderId);
  },
  getOrderId() {
    return localStorage.getItem(ORDERID);
  },
};

export default LocalStorage;
